import React from 'react'
import type { OptionProps } from '../../common/Option'
import { Option } from '../../common/Option'
import { withFormikSupport } from '../../hocs/withFormikSupport/withFormikSupport'
import type { RadioButtonProps } from './types'

const RadioButtonComponent = ({
  value,
  name,
  tooltip,
  checkedValue,
  label,
  suggestion,
  disabled,
  tabIndex,
  inputRef,
  onChange,
  onBlur,
  onValueChange,
}: RadioButtonProps) => {
  const handleChange: OptionProps['onChange'] = (e) => {
    if (onChange) onChange(e)
    if (onValueChange) onValueChange(e.target.value)
  }

  return (
    <Option
      label={label}
      name={name}
      tooltip={tooltip}
      checked={checkedValue === value}
      value={checkedValue}
      suggestion={suggestion}
      disabled={disabled}
      tabIndex={tabIndex}
      inputRef={inputRef}
      onChange={handleChange}
      onBlur={onBlur}
    />
  )
}

export const RadioButton = withFormikSupport(RadioButtonComponent)
